<div class="filter-users">
  <div class="modal-main py-2">
    <div class="header">
      <div class="d-flex flex-row justify-content-between my-1">
        <div class="col-1 pointer-cursor">
          <ng-container *ngIf="stepper !== 1">
            <img
              src="/assets/svg/ico-chevron-back-outline.svg"
              class="back-navigation pointer-cursor"
              (click)="navigateBack()"
              role="button"
            />
          </ng-container>
        </div>
        <div>
          <p class="modal-title text-center">
            {{ 'FILTER_USER' | translate }}
          </p>
        </div>
        <div class="col-1 text-right">
          <img
            src="/assets/svg/ico-hamburger-close.svg"
            class="pointer-cursor"
            (click)="closeDialog()"
          />
        </div>
      </div>
      <div class="row my-4 mx-3 pt-1 justify-content-center">
        <div class="col-3"></div>
        <div class="col-6">
          <p class="text-center heading1">
            {{ 'FILTER_BY_USER_TYPE' | translate }}
          </p>
        </div>
        <div class="col-3" role="button" (click)="resetFilter()">
          <p
            class="text-right"
            [ngClass]="{
              'reset-btn': selectedRoles?.length === 0,
              'reset-btn-active': selectedRoles?.length > 0
            }"
          >
            {{ 'RESET' | translate }}
          </p>
        </div>
      </div>
    </div>

    <ng-container *ngIf="stepper === 1">
      <div class="scroll-container mx-3">
        <div
          class="row py-2 filter-item pointer-cursor only-element"
          (click)="changeStep(CONSTANTS.USER_TYPE)"
        >
          <div
            class="col-2 text-center d-flex flex-row justify-content-center align-items-center"
          >
            <img src="assets/svg/ico-user-group-circle.svg" class="icon" />
          </div>
          <div
            class="col-8 text-item d-flex flex-column justify-content-center"
          >
            <p class="item-title">
              {{ 'USER_TYPE' | translate }}
            </p>
            <p class="item-description ellipsis mb-0">
              <app-with-tooltip [showHelpCursor]="true">
                {{ (selectedRoles | userTypeResponse) | translate }}
              </app-with-tooltip>
            </p>
          </div>

          <div
            class="col-2 text-right d-flex flex-row justify-content-end align-items-center pr-3 pointer-cursor"
            role="button"
          >
            <img src="assets/svg/ico-chevron-forward-outline.svg" />
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="userRoles?.length > 0 && stepper === 2">
      <div class="scroll-container mx-3">
        <div
          class="row py-2 filter-item pointer-cursor"
          *ngFor="let role of userRoles | orderBy: ['role']; let i = index"
          [ngClass]="{
            'top-element': i === 0 && userRoles.length !== 1,
            'last-element':
              i === userRoles.length - 1 && userRoles.length !== 1,
            'middle-element': i !== 0 && i !== userRoles.length - 1,
            'only-element': userRoles.length === 1
          }"
        >
          <div
            class="col-2 text-center d-flex flex-row justify-content-center align-items-center"
          >
            <img src="assets/svg/ico-user-group-circle.svg" class="icon" />
          </div>
          <div
            class="col-8 text-item d-flex flex-column justify-content-center"
          >
            <p class="item-title">
              {{ (role.value | userTypeResponse) | translate }}
            </p>
          </div>
          <div
            class="col-2 text-right d-flex flex-row justify-content-end align-items-center pr-3 pointer-cursor"
            role="button"
            (click)="selectUserType(role.value)"
          >
            <img src="assets/svg/ico-circle.svg" *ngIf="!role.active" />

            <img
              *ngIf="role.active"
              src="assets/svg/ico-checkmark-circle-outline.svg"
            />
          </div>
        </div>
      </div>
    </ng-container>

    <div class="row mt-4 pt-1 mx-3">
      <button
        class="btn btn-danger px-3 w-100 result-btn"
        type="button"
        tabindex="0"
        (click)="applyFilter()"
      >
        {{ 'SEE_RESULTS' | translate }}
      </button>
    </div>
  </div>
</div>
